export default __webpack_public_path__ + "static/media/DNo.29-3.c23eede4.jpg";